import { render, staticRenderFns } from "./UploadFileFormTableFile.vue?vue&type=template&id=0ff340ca&scoped=true&"
import script from "./UploadFileFormTableFile.vue?vue&type=script&lang=js&"
export * from "./UploadFileFormTableFile.vue?vue&type=script&lang=js&"
import style0 from "./UploadFileFormTableFile.vue?vue&type=style&index=0&id=0ff340ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff340ca",
  null
  
)

export default component.exports